import { render } from "./PatriciaCharacter.vue?vue&type=template&id=6fc4e316&scoped=true"
import script from "./PatriciaCharacter.vue?vue&type=script&lang=js"
export * from "./PatriciaCharacter.vue?vue&type=script&lang=js"

import "./PatriciaCharacter.vue?vue&type=style&index=0&id=6fc4e316&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fc4e316"]])

export default __exports__